// extracted by mini-css-extract-plugin
export var csatScore = "_no-5";
export var header = "_no-1";
export var panelWrapper = "_no-2";
export var postPreview = "_no-3";
export var rightContent = "_no-0";
export var wrappingText = "_no-4";